if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection?.querySelector('.product-info');
      this.productForm = this.productInfo?.querySelector('product-form');
      this.form = this.productForm?.querySelector('.js-product-form-main');
      this.mainButton = this.productForm?.querySelector('[name="add"]');
      this.button = this.querySelector('[data-sticky-add]');
      if (!this.form || !this.mainButton || !this.button) return;

      // Reuse the main form, including its selected variant, quantity and app fields.
      // A second form could silently submit a stale variant or quantity.
      this.submitHandler = () => {
        if (!this.mainButton.disabled && this.mainButton.getAttribute('aria-disabled') !== 'true') {
          this.form.requestSubmit(this.mainButton);
        }
      };
      this.button.addEventListener('click', this.submitHandler);
      this.syncButton = () => {
        this.button.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        this.button.textContent = this.mainButton.textContent;
        this.button.classList.toggle('is-loading', this.mainButton.classList.contains('is-loading'));
      };
      this.syncButton();
      this.buttonObserver = new MutationObserver(this.syncButton);
      this.buttonObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });

      const mainPrice = this.productInfo.querySelector('.product-info__price .price');
      const stickyPrice = this.querySelector('.card__info .price');
      if (mainPrice && stickyPrice) {
        const syncPrice = () => { stickyPrice.innerHTML = mainPrice.innerHTML; stickyPrice.className = mainPrice.className; };
        syncPrice();
        this.priceObserver = new MutationObserver(syncPrice);
        this.priceObserver.observe(mainPrice, { attributes: true, childList: true, subtree: true, characterData: true });
      }
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.productForm && !theme.mediaMatches.md) {
              this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
            } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
              this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            }
          });
        });
        this.intersectionObserver.observe(this.productForm);
        this.intersectionObserver.observe(this.productInfo);
      }
      window.addEventListener('scroll', StickyAtcPanel.handleScroll, { passive: true });
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.submitHandler);
      this.buttonObserver?.disconnect();
      this.priceObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    static handleScroll() {
      document.body.classList.toggle('scrolled-to-bottom', window.scrollY + window.innerHeight + 100 > document.body.scrollHeight);
    }
  }
  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
